function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 18,
  className: "lds-bars",
  preserveAspectRatio: "xMidYMid",
  style: {
    background: "0 0"
  },
  viewBox: "25 25 50 50",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17 30h6v40h-6z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.6s",
  calcMode: "spline",
  dur: 1,
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  keyTimes: "0;0.5;1",
  repeatCount: "indefinite",
  values: "1;0.2;1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37 30h6v40h-6z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.4s",
  calcMode: "spline",
  dur: 1,
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  keyTimes: "0;0.5;1",
  repeatCount: "indefinite",
  values: "1;0.2;1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M57 30h6v40h-6z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "-0.2s",
  calcMode: "spline",
  dur: 1,
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  keyTimes: "0;0.5;1",
  repeatCount: "indefinite",
  values: "1;0.2;1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M77 30h6v40h-6z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  begin: "0s",
  calcMode: "spline",
  dur: 1,
  keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
  keyTimes: "0;0.5;1",
  repeatCount: "indefinite",
  values: "1;0.2;1"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-spin-bar.svg";
export { SvgComponent as ReactComponent };